const { produce } = require("immer");

const init = {
  uid: null,
  login: null,
  password: null,
  group: null,
  profile: null,
  validated: true,
  // contact: {
  //   email: null,
  //   phone: null,
  //   mobile: null
  // },
  // personal: {
  //   firstName: null,
  //   lastName: null,
  //   birthDate: null,
  //   gender: null
  // }
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_memberForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
      });

    case "UPDATE_memberForm":
      return produce(state, draft => {
        Object.assign(draft, action.form/*, {
          contact: Object.assign(draft.contact, action.form.contact),
          personal: Object.assign(draft.personal, action.form.personal)
        }*/);
      });

    case "RESET_memberForm":
      return init;

    default:
      return state;
  }
}
